import Layout from './Layout/Layout';
import HelpLayout from './HelpLayout/HelpLayout';
import SimpleLayout from './SimpleLayout/SimpleLayout';
import FeedbackPage from './FeedbackPage/FeedbackPage';
import PayLaterAutoreply from './Emails/payLaterAutoreply';

export { HelpLayout, SimpleLayout, Layout, FeedbackPage, PayLaterAutoreply };
